var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4591 0.730693L8.14213 6.04766L2.82514 0.730663C2.58293 0.488452 1.72884 0.292158 1.07107 0.949929C0.413297 1.6077 0.609619 2.46182 0.851801 2.704L6.16882 8.02103L0.85183 13.338C0.609619 13.5802 0.413297 14.4343 1.07104 15.092C1.72878 15.7498 2.58293 15.5535 2.82511 15.3113L8.14213 9.99428L13.4592 15.3113C13.7013 15.5535 14.5554 15.7498 15.2132 15.092C15.871 14.4342 15.6747 13.5801 15.4325 13.338L10.1155 8.02094L15.4325 2.70392C15.6747 2.46176 15.871 1.60764 15.2132 0.949843C14.5554 0.292044 13.7013 0.488509 13.4591 0.730693Z",
    fill: "#f00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRed);
export default __webpack_public_path__ + "static/media/cross-red.ff4219b1f62d997d3a9531db8e44b68f.svg";
export { ForwardRef as ReactComponent };